import React from "react";
import { LightbulbIcon } from "lucide-react";
import { Section } from "./Section";
import { SectionHeading } from "./SectionHeading";
import { challenges } from "../data/challenges";
export function ChallengesSection() {
  return <Section tone="white" cta={{
    label: "Yes, I want a more organized GI nutrition reference system",
    sub: "$27 USD · One-Time Payment"
  }} data-id="element-76" data-mp="k18btkd1o1oo">
      <SectionHeading eyebrow="Does any of this sound familiar?" title="6 professional challenges this collection was designed to address" intro={<p data-id="element-78" data-mp="3simep1jjdpsi">If you work or study in gastrointestinal nutrition, you may recognize some of these situations.</p>} data-id="element-77" data-mp="3nhynaereb6xr" />

      <ol className="mx-auto mt-12 grid max-w-5xl gap-5 md:grid-cols-2" data-id="element-79" data-mp="5bu38ehaloac">
        {challenges.map((c, i) => <li key={c.title} className="flex flex-col rounded-3xl bg-paper p-6 md:p-7" data-id="element-80" data-mp="1cpx5iybrt4qe" data-mpi={i}>
            <div className="flex items-start gap-4" data-id="element-81" data-mp="1gqz9ttkjo6z8">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-navy-950 font-display text-xl font-black text-accent" data-id="element-82" data-mp="1gpedpzil0fz9">
                {i + 1}
              </span>
              <h3 className="font-display text-[20px] font-extrabold leading-tight md:text-[22px]" data-id="element-83" data-mp="26j41t8gjsqoi">{c.title}</h3>
            </div>
            <div className="mt-4 space-y-2.5 text-[15px] leading-relaxed text-muted" data-id="element-84" data-mp="21lc9wefwl4kb">
              {c.body.map(p => <p key={p} data-id="element-85" data-mp="1sijkkgqa72x4">{p}</p>)}
            </div>
            <div className="mt-auto pt-5" data-id="element-86" data-mp="1skw9xeydcfk7">
              <div className="rounded-2xl bg-white p-4 ring-1 ring-brand/20" data-id="element-87" data-mp="1nrtcgvqh0lyq">
                <p className="flex items-center gap-1.5 text-[13px] font-extrabold uppercase tracking-wide text-brand" data-id="element-88" data-mp="1isqj48jus46l">
                  <LightbulbIcon className="h-4 w-4" aria-hidden="true" data-id="element-89" data-mp="1duoocqd2egfa" /> The Blueprint approach
                </p>
                <p className="mt-1.5 text-[15px] font-medium leading-snug text-ink" data-id="element-90" data-mp="19r0fm4cp5esg">{c.approach}</p>
              </div>
            </div>
          </li>)}
      </ol>

      <div className="mx-auto mt-12 max-w-3xl rounded-3xl bg-navy-950 p-7 text-center text-white md:p-10" data-id="element-91" data-mp="v53flof5xjhm">
        <p className="font-display text-[24px] font-extrabold leading-tight md:text-3xl" data-id="element-92" data-mp="z7gk69i6bbct">
          The challenge isn't always a lack of information.
        </p>
        <p className="mt-3 text-lg font-semibold text-cta" data-id="element-93" data-mp="l9s033vxk88t">Sometimes, the real challenge is organizing the information you already have.</p>
        <p className="mt-4 text-[15px] leading-relaxed text-white/75 md:text-base" data-id="element-94" data-mp="1dvul2ew14pqq">
          GI Nutrition Clinical Blueprint™ brings related educational topics together in one collection, giving you a practical starting point for building a more organized professional reference library.
        </p>
      </div>
    </Section>;
}